/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalUserEmailUpdateResponse
 */
export interface ExternalUserEmailUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof ExternalUserEmailUpdateResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserEmailUpdateResponse
     */
    email?: string | null;
}

/**
 * Check if a given object implements the ExternalUserEmailUpdateResponse interface.
 */
export function instanceOfExternalUserEmailUpdateResponse(value: object): value is ExternalUserEmailUpdateResponse {
    return true;
}

export function ExternalUserEmailUpdateResponseFromJSON(json: any): ExternalUserEmailUpdateResponse {
    return ExternalUserEmailUpdateResponseFromJSONTyped(json, false);
}

export function ExternalUserEmailUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserEmailUpdateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function ExternalUserEmailUpdateResponseToJSON(json: any): ExternalUserEmailUpdateResponse {
    return ExternalUserEmailUpdateResponseToJSONTyped(json, false);
}

export function ExternalUserEmailUpdateResponseToJSONTyped(value?: ExternalUserEmailUpdateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'email': value['email'],
    };
}

